import type {
  RatingMenuConnectorParams,
  RatingMenuWidgetDescription,
} from "instantsearch.js/es/connectors/rating-menu/connectRatingMenu";
import connectRatingMenu from "instantsearch.js/es/connectors/rating-menu/connectRatingMenu";
import { useTranslations } from "next-intl";
import { useConnector } from "react-instantsearch";
import { RefinementListClassNames } from "react-instantsearch/dist/es/ui/RefinementList";

import Checkbox from "../form/checkbox";
import styles from "./search-filter-reviews.module.scss";

export type UseRatingMenuProps = RatingMenuConnectorParams & {
  classNames?: Partial<RefinementListClassNames>;
};

export function useRatingMenu(props?: UseRatingMenuProps) {
  return useConnector<RatingMenuConnectorParams, RatingMenuWidgetDescription>(connectRatingMenu, props);
}

export function RatingMenu(props: UseRatingMenuProps) {
  const { items, refine } = useRatingMenu(props);
  const t = useTranslations();

  return (
    <>
      <svg className={styles.hiddenStar}>
        <symbol id="ais-RatingMenu-starSymbol" viewBox="0 0 12 12">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m6 1.5 1.484 2.963 3.316.475-2.4 2.306.567 3.256L6 8.963 3.034 10.5 3.6 7.244 1.2 4.938l3.317-.475L6 1.5Z"
            fill="#252B2E"
          />
        </symbol>
        <symbol id="ais-RatingMenu-starEmptySymbol" viewBox="0 0 12 12">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m6 1.5 1.484 2.963 3.316.475-2.4 2.306.567 3.256L6 8.963 3.034 10.5 3.6 7.244 1.2 4.938l3.317-.475L6 1.5Z"
            fill="#B5B5B5"
          />
        </symbol>
      </svg>

      <ul className={props.classNames?.list}>
        {items.map((item, i) => (
          <li key={i}>
            <Checkbox
              className={styles.checkboxContainer}
              label={
                <div className={props.classNames?.item}>
                  {item.stars.map((isFilled, index) => (
                    <svg key={index} className={styles.star} aria-hidden="true" width="12" height="12">
                      {isFilled ? (
                        <use href="#ais-RatingMenu-starSymbol"></use>
                      ) : (
                        <use href="#ais-RatingMenu-starEmptySymbol"></use>
                      )}
                    </svg>
                  ))}
                  <span className={styles.text}>{t(`algolia.averageRatingUp${item.value}`)}</span>
                </div>
              }
              onChange={() => refine(item.value)}
              checked={item.isRefined}
            />
          </li>
        ))}
      </ul>
    </>
  );
}
